// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1610":"2729d323","2501":"9d54ca4a","3223":"bc61615d","5087":"2e4f9787","5303":"bc61615d","5331":"bc61615d","9024":"6fef2697"}[chunkId] + ".chunk.css";
};